import IdentitiesApi from 'api/v2/admins/identities-api'
import React,{ useState, useEffect } from 'react'
import { Card, CardHeader, Button, Table,Alert } from 'reactstrap'
import TimeUtil from 'utils/time-util'
import PropTypes from 'prop-types'

const propTypes = {
  selectedCustomer: PropTypes.object
}

const defaultProps = {
  accounts: []
}

const AccountLinkCustomerDetailView = ({ selectedCustomer }) => {
  const [ customer, setCustomer ] = useState(undefined)

  useEffect(() => {
    if (selectedCustomer.email) {
      IdentitiesApi.getCustomerProfile(selectedCustomer.email)
        .then((response) => {
          setCustomer(response.data.customer)
        })
        .catch((error) => {
          console.log(error)
        })
    }

  }, [ selectedCustomer.email ])

  return (
    <>
      {
        customer && (
          <Card>
            <CardHeader>
              <div>
                <span className='small text-uppercase text-light font-weight-bolder'>
                  { selectedCustomer?.type }
                </span>
                <h2>
                  <span className='mr-3'>
                    { customer?.name }
                  </span>
                </h2>
                { /* NOTE: will create a component to display customer detail  */ }
                <a
                  href={ `/app/customers/${customer.id}` }
                  target="_blank" rel="noreferrer"
                >
                  <Button
                    size="sm"
                    type='button'
                    color="primary"
                  >
                    Click to see Customer Detail
                  </Button>
                </a>

                <h2 className='mt-3'>
                  Customer Latest Orders
                </h2>
                {
                  customer.last_orders.length > 0 &&
                  (
                    <Table>
                      <thead>
                        <tr>
                          <th>Number</th>
                          <th>Date</th>
                          <th>Payment Method</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        { customer.last_orders.map((order) => (
                          <tr key={ `customer-order-${order.number}` }>
                            <th scope="row">{ order.number }</th>
                            <td>{ TimeUtil.format(order.created_at) }</td>
                            <td>{ order.payments[0].payment_method_name }</td>
                            <td>
                              <a
                                href={ `/app/customer-orders/${order.id}` }
                                target="_blank" rel="noreferrer"
                              >
                                <Button
                                  size="sm"
                                  type='button'
                                  color="primary"
                                >
                                  Detail
                                </Button>
                              </a>
                            </td>
                          </tr>
                        )) }
                      </tbody>
                    </Table>
                  )
                }
                <Alert
                  className={ customer.last_orders.length > 0 ? 'd-none' : 'd-block' }
                  color='info'
                >
                  <i className='fas fa-info-circle mr-3' />
                  <span>
                    { 'Customer has no orders' }
                  </span>
                </Alert>
              </div>
            </CardHeader>
          </Card>
        )
      }
    </>
  )
}

AccountLinkCustomerDetailView.propTypes    = propTypes
AccountLinkCustomerDetailView.defaultProps = defaultProps


export default AccountLinkCustomerDetailView